import React from 'react';

import { Box, Separator, Text, useTheme } from '@ublend-npm/aulaui-core';

import { EDUCATOR_ROLE } from '@core/constants/space';

import ParticipantHistoryAccordion from './ParticipantHistoryAccordion';
import ParticipantHistoryItem from './ParticipantHistoryItem';
import { ParticipantHistoryEvent } from './types';

type ParticipantHistoryDateProps = {
  date: string;
  events: Array<ParticipantHistoryEvent>;
};

const ParticipantHistoryDate = ({
  date,
  events,
}: ParticipantHistoryDateProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ pt: { xs: 2.5, lg: 3 } }}>
      <Text color={theme.palette.text.secondary} sx={{ fontWeight: 500 }}>
        {date}
      </Text>
      {events.map((event) => {
        if (event.data.length >= 3) {
          return <ParticipantHistoryAccordion event={event} />;
        }

        return (
          <Box key={event.eventType}>
            {event.data.map((ev) => (
              <ParticipantHistoryItem
                avatar={ev.participant.avatar}
                isEducator={ev.role === EDUCATOR_ROLE}
                firstName={ev.participant.firstName}
                lastName={ev.participant.lastName}
                responsible={event.user}
                type={event.eventType}
              />
            ))}
          </Box>
        );
      })}
      <Separator size="thin" sx={{ p: 0 }} />
    </Box>
  );
};

export default ParticipantHistoryDate;
